import Enllac from 'components/corporatiu/Enllac';
import clsx from 'clsx';
import styles from './menusecundari.module.scss';
import Image from 'next/image';
import Icona from 'components/corporatiu/ui/Icona';
import { dataResources } from 'utils/constants';

const imageLoader = ({ src }) => {
    return `${src}`;
};

const { basePath } = dataResources;

const titolSeccio = (seccio, opcio) => {
    switch (seccio) {
        case 'corporatiu':
            return (
                <Enllac href='/corporatiu/ca/el-grup/' title='Corporació 3Cat' className={styles.secundariTitol}>
                    Corporatiu
                </Enllac>
            );
        case 'tv3':
            return (
                <Enllac href='https://www.3cat.cat/tv3/' title='TV3' className={styles.secundariTitol}>
                    <Image
                        loader={imageLoader}
                        unoptimized={true}
                        width={49}
                        height={40}
                        alt='TV3'
                        src={basePath + '/_resources/logos/tv3_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                    />
                </Enllac>
            );
        case 'catradio':
            return (
                <Enllac href='https://www.3cat.cat/catradio/' title='Catalunya Ràdio' className={styles.secundariTitol}>
                    <Image
                        loader={imageLoader}
                        unoptimized={true}
                        width={144}
                        height={24}
                        alt='Catalunya Ràdio'
                        src={basePath + '/_resources/logos/catradio_monoBgGroc_horitzontal.svg?v=JIT_ENV_RESOURCES_VERSION'}
                    />
                </Enllac>
            );
        case 'avis-legal':
            return (
                <Enllac href='/avis-legal/' title='Avís legal' className={styles.secundariTitol}>
                    Avís legal
                </Enllac>
            );
    }
};

const peuSideMenu = () => {
    return (
        <div className={styles.peuMenu} aria-label='Enllaços peu del menú'>
            <div className={styles.peuLogo}>
                <Enllac href='/3cat/'>
                    <Image
                        loader={imageLoader}
                        unoptimized={true}
                        width={82}
                        height={24}
                        alt='Logo 3Cat'
                        src={basePath + '/_resources/logos/3cat_color.svg?v=JIT_ENV_RESOURCES_VERSION'}
                    />
                </Enllac>
            </div>

            <div className={styles.peuMarques}>
                <Enllac href='https://www.3cat.cat/tv3/' className={styles.peuTv3}>
                    <div className={styles.logotv3}>
                        <Image
                            loader={imageLoader}
                            unoptimized={true}
                            width={32}
                            height={24}
                            alt='TV3'
                            src={basePath + '/_resources/logos/tv3_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                        />
                    </div>
                </Enllac>
                <Enllac href='https://www.3cat.cat/catradio/' className={styles.peuCr}>
                    <Image
                        loader={imageLoader}
                        unoptimized={true}
                        width={32}
                        height={24}
                        alt='Catalunya Ràdio'
                        src={basePath + '/_resources/logos/cr_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                    />
                </Enllac>
                <Enllac href='/3catinfo/' className={styles.peuInfo}>
                    <Image
                        loader={imageLoader}
                        unoptimized={true}
                        width={90}
                        height={18}
                        alt='3catinfo'
                        src={basePath + '/_resources/logos/3catinfo_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                    />
                </Enllac>
                <Enllac href='https://www.3cat.cat/tv3/sx3/' className={styles.peuSx3}>
                    <Image
                        loader={imageLoader}
                        unoptimized={true}
                        width={40.74}
                        height={20}
                        alt='SX3'
                        src={basePath + '/_resources/logos/sx3_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                    />
                </Enllac>
                <Enllac href='/3cat/eva/' className={styles.peuEva}>
                    <Image
                        src={basePath + '/_resources/logos/eva_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                        loader={imageLoader}
                        unoptimized={true}
                        width={40.87}
                        height={18}
                        alt='EVA'
                    ></Image>
                </Enllac>
            </div>
            <div>
                <ul className={styles.peuAltres}>
                    <li className={styles.peuCorpo}>
                        <Enllac href='/corporatiu/ca/el-grup/'>Corporatiu</Enllac>
                    </li>
                    <li>
                        <Enllac href='https://botiga.3cat.cat/'>Botiga</Enllac>
                    </li>
                    <li>
                        <Enllac href='/cercador/?profile=portalunic' className={styles.peuCerca}>
                            Cerca
                            <Icona className={styles.ico_cerca} icona='cercador' alt='' isBlanc={true} mida={18} />
                        </Enllac>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export { titolSeccio, peuSideMenu };
